export { default as CoreAsyncWebStorage } from './async';
export { default as CoreSyncWebStorage } from './sync';